

















import {
  defineComponent,
  PropType,
  computed,
} from '@vue/composition-api';
import { styleRecordPxToVm } from '@/shared/utils/style-unit';
import type { HeaderConfig } from '../../config/types';

export default defineComponent({
  name: 'AtmosphericHeader',
  props: {
    config: {
      type: Object as PropType<HeaderConfig>,
      required: true,
    },
  },
  setup(props) {
    /** 背景图样式 */
    const backgroundStyle = computed(() => styleRecordPxToVm(props.config.backgroundStyle));
    /** 容器样式 */
    const containerStyle = computed(() => styleRecordPxToVm(props.config.containerStyle));

    return {
      backgroundStyle,
      containerStyle,
    };
  },
});
